import { Button } from '@mui/material';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useAppSelector } from '../../redux/hooks';
import { selectTripsList } from '../../redux/trip/trip.selectors';
import { selectCurrentUser } from '../../redux/user/user.selectors';

function ForbiddenError403() {
  const currentUser = useAppSelector(selectCurrentUser);
  const tripsList = useAppSelector(selectTripsList);

  // Determine where to redirect user based on authentication and trip ownership
  let route: string;
  if (currentUser && tripsList && tripsList.length === 0) {
    route = '/';
  } else if (currentUser && tripsList && tripsList.length >= 1) {
    route = '/trips';
  } else if (currentUser && !tripsList) {
    route = '/trips';
  } else {
    route = '/login';
  }
  return (
    <>
      <Helmet>
        <title> Forbidden Error 403</title>
      </Helmet>
      <div className='error-container'>
        <img
          className='error-image'
          src='/svgs/403.png'
          alt='403 Forbidden Error'
        />
        <div className='error-message'>You&apos;ve wandered into restricted territory</div>
        <div className='error-message-subtext'>*request access from the owner of this trip</div>
        <Button
          className='error-redirect-btn'
          href={route}
        >
          Head Back Home
        </Button>
      </div>
    </>
  );
}

ForbiddenError403.displayName = 'ForbiddenError403';
export default ForbiddenError403;
